import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import {
  useLogin,
  useNotify,
  useTranslate,
  useRedirect,
  useAuthState,
  useSetLocale,
} from "react-admin";

import themeConfig from "../../config";
import { AuthLayout } from "../../layouts/AuthLayout";

import SecurityScript from '../../components/SecurityScript';

import {
  Button,
  CircularProgress,
  makeStyles,
  Box,
  Typography,
  TextField,
  useTheme,
  useMediaQuery,
} from "@material-ui/core";
import { LoaderApp } from "../../components/layout/LoaderApp";

const useStyles = makeStyles((theme) => ({
  linkPassword: {
    color: "#00D8D8",
    textDecoration: "none",
    marginTop: theme.spacing(1),
  },
  inputAdornmentColor: {
    fill: themeConfig.companySecondaryColor,
  },
}));

export default function Login() {
  const classes = useStyles();
  const translate = useTranslate();
  const [btnSubmit, setBtnSubmit] = useState(true);
  const { register, handleSubmit, watch } = useForm();
  const login = useLogin();
  const notify = useNotify();
  const redirect = useRedirect();
  const setLocale = useSetLocale();
  const { authenticated, loaded } = useAuthState();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleLogin = (data, event) => {
    if (data.email !== "" && data.password !== "") {
      setBtnSubmit("loading");
      login({
        username: data.email,
        password: data.password,
      })
        .then((auth) => {
          if (auth.status && auth.status === "NEW_PASSWORD_REQUIRED") {
            notify(translate('ra.auth.change_password'), "warning");
            redirect("/change-password-temp", "", undefined, undefined, { username: auth.user, password: auth.password, auth: auth.auth })
          } else if (auth.status && auth.status === "CUSTOM_CHALLENGE") {
            redirect("/verify-otp", "", undefined, undefined, { username: auth.user, password: auth.password, auth: auth.auth })
          } else {
            if (themeConfig.companyName.includes("Bancaribe")) {
              window.localStorage.setItem('language', 'es');
              setLocale("es");
            }
            setBtnSubmit(false);
            redirect("/");
          }
        })
        .catch((err) => {
          setBtnSubmit(true);
          notify(err.message, "warning");
        });
      event.target.reset();
    } else {
      setBtnSubmit(false);
    }
  };

  useEffect(() => {
    if (loaded && authenticated) {
      redirect("/");
    }
  }, [loaded]);

  return (
    <>
      {
        btnSubmit === "loading" && (
          <LoaderApp />
        )
      }
      <AuthLayout>
        <form onSubmit={handleSubmit(handleLogin)} style={{ width: "100%" }}>
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            gridGap={theme.spacing(2)}
            width="100%"
            margin="0 auto"
            maxWidth={isMobile ? "90%" : "440px"}
          >
            <TextField
              fullWidth
              {...register("email", { required: true })}
              label={translate("ra.fieldsName.users.email")}
              style={{
                fontSize: 17,
                height: 50,
              }}
              type="email"
              variant="outlined"
              required
            />
            <TextField
              fullWidth
              {...register("password", { required: true })}
              label={translate("ra.auth.passwordField")}
              //onChange={(e) => setValue(e.target.value)}
              style={{
                fontSize: 17,
                height: 50,
              }}
              type="password"
              variant="outlined"
              required
            />
            <Box
              width="100%"
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <Link to="/reset-password" className={classes.linkPassword}>
                <Typography variant="body1">
                  {translate("ra.auth.forgotPassword")}
                </Typography>
              </Link>
            </Box>
            <Button
              fullWidth
              type="submit"
              variant={btnSubmit === "loading" ? "outlined" : "contained"}
              color="primary"
              size="large"
              style={{
                marginTop: theme.spacing(6),
                height: 50,
                borderRadius: 12,
              }}
              disabled={
                !watch("email") || !watch("password")
              }
            >
              {btnSubmit === "loading" ? (
                <CircularProgress color="primary" size="1.5rem" />
              ) : (
                translate("ra.action.login")
              )}
            </Button>

            <SecurityScript />
          </Box>
        </form>
      </AuthLayout>
    </>

  );
}
